var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgIconManagestriim = function SvgIconManagestriim(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.568 17.437a1.389 1.389 0 01-.964-1.035 1.437 1.437 0 00-2.144-.888c-1.286.784-2.758-.688-1.975-1.975a1.437 1.437 0 00-.888-2.143c-1.463-.355-1.463-2.437 0-2.792a1.437 1.437 0 00.889-2.144c-.783-1.286.688-2.758 1.975-1.975a1.435 1.435 0 002.143-.888c.355-1.463 2.437-1.463 2.792 0a1.437 1.437 0 002.144.889c1.286-.783 2.758.688 1.975 1.975a1.436 1.436 0 00.887 2.143c1.094.265 1.37 1.495.83 2.248m-.565 6.648l1.666-1.667-1.666-1.666m-2.5 0L12.5 15.833l1.667 1.667M7.5 10a2.5 2.5 0 105 0 2.5 2.5 0 00-5 0z",
    stroke: "#48525C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgIconManagestriim;